module.exports = __webpack_public_path__ + "assets/img/web04.46fdac14.png";